
//  =================================================
//TODO check if this are the correct values, now this values are in parts from FLW24
// =================================================

export const FLM = {
	defaultValues: {
		height: 1000,
		width: 1000,
		windowQuantity: 1,
		ug: {
			glass0: 0
		},
		psi:  {
			glass0: 0
		},
		isolation: false,
		glassThickness: 8,
		middleMullion: false,
		glassTypes: 0
	},
	fixedValues: {
		middleMullion: true,
		glass: [{name: '8 ESG / VSG', value: 8}, {name: '10 ESG / VSG', value: 10}, {name: '12 ESG / VSG', value: 12}],
		isolation: false,
	},
	edgeTop: {
		W_m2K: 4.349,
		width: 43
	},
	edgeSide: {
		W_m2K: 4.081,
		width: 62
	},
	edgeBottom: {
		W_m2K: 4.475,
		width: 43
	},
	louvre: {
		W_m2K: 3.601,
		width: 43
	},
	middleMullion: {
		W_m2K: 4.137,
		width: 104,
		min: 500,
		max: 2980
	},
	windowWidth: {
		min: 300,
		max: 1500
	},
	windowHeight: {
		min: 200,
		max: 3000
	},
	louvreHeight: {
		min: 170,
		max: 244
	},
	edgeWidth: 37,
	gabDimensions: {
		side: 2.5,
		top: 3,
		middle: 14.1,
		bottom: 4
	},
	allowance: {
		width: 0,
		height: 0
	},
	area: {},

	//TODO cvReference85deg value from flw24 maybe change to flm??
	cvReference85deg: 0.61,
	cvFactors: {cv1: 0.044, cv2: 0.012, cv3: 0.05},
	dimensionsOpenLouvre: {
		sideMullion: 39.5,
		profileTop: 24.5,
		profileBottom: 26.5,
		louvre: [8,10,12],
		mm: 58
	},
	windLoadCalculation: {
		wl1100: [{
			wMax: 1416,
			hMax: 244,
			aMax: 0.36
		}],
		wl1250: [{
			wMax: 1226,
			hMax: 244,
			aMax: 0.3
		}],
		wl1750: [{
			wMax: 1226,
			hMax: 244,
			aMax: 0.36
		}],
		wl2000: [{
			wMax: 1416,
			hMax: 144,
			aMax: 0.3
		}],
		wl2250: [{
			wMax: 1416,
			hMax: 244,
			aMax: 0.36
		}],
		wl2900: [{
			wMax: 1226,
			hMax: 244,
			aMax: 0.3
		}],
	}

};

